import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ArticleHero = ({ blog }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
      {blog?.image && (
        <Image
          src={blog?.image}
          alt={blog?.imageAlt || blog?.title}
          className="w-full h-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 lg:p-12">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="inline-block px-3 py-1 bg-accent text-accent-foreground rounded-md text-sm font-medium">
              {blog?.category}
            </span>
            {blog?.featured && (
              <span className="inline-block px-3 py-1 bg-yellow-500 text-slate-900 rounded-md text-sm font-medium">
                Featured
              </span>
            )}
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            {blog?.title}
          </h1>
          <div className="flex flex-wrap items-center gap-4 text-white/90 text-sm md:text-base">
            <div className="flex items-center gap-2">
              {blog?.author?.avatarUrl && (
                <Image
                  src={blog?.author?.avatarUrl}
                  alt={blog?.author?.fullName}
                  className="w-10 h-10 rounded-full object-cover border-2 border-white/20"
                />
              )}
              <span className="font-medium">{blog?.author?.fullName}</span>
            </div>
            <span className="text-white/50">•</span>
            <div className="flex items-center gap-1.5">
              <Icon name="Calendar" size={16} color="white" />
              <span>{formatDate(blog?.publishedDate)}</span>
            </div>
            <span className="text-white/50">•</span>
            <div className="flex items-center gap-1.5">
              <Icon name="Clock" size={16} color="white" />
              <span>{blog?.readTime} min read</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleHero;